import { useLayoutEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
// import '../App.module.css';

const Chart = ({ chartId, data }) => {
  am4core.useTheme(am4themes_animated);
  const stringifiedData = JSON.stringify(data);
  useLayoutEffect(() => {
    // 차트 인스턴스 생성
    let chart = am4core.create(chartId, am4charts.XYChart);
    chart.responsive.enabled = true;
    chart.data = JSON.parse(stringifiedData);

    // 차트 바 뒤쪽의 회색 배경 관련해서 rectangle 요소 추가
    let rect = chart.createChild(am4core.RoundedRectangle);
    rect.width = am4core.percent(65);
    rect.height = 6.2;
    rect.dx = 0;
    rect.dy = -69.2;
    rect.fill = am4core.color('#C4C4C4');
    rect.fillOpacity = 0.3;
    let rect2 = chart.createChild(am4core.RoundedRectangle);
    rect2.width = am4core.percent(65);
    rect2.height = 6.2;
    rect2.dx = 0;
    rect2.dy = -31.2;
    rect2.fill = am4core.color('#C4C4C4');
    rect2.fillOpacity = 0.3;

    // 차트의 값 포맷팅
    chart.numberFormatter.numberFormat = '#.##%';

    // chart의 x, y축 설정
    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'type';
    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    let series = chart.series.push(new am4charts.ColumnSeries());
    series.name = 'Result';
    // series.columns.template.tooltipText = '타입: {categoryY}\n결과: {valueX}';
    series.dataFields.valueX = 'rate';
    series.dataFields.categoryY = 'type';

    // chart bar와 border의 크기 지정
    series.columns.template.height = 6.05;
    series.columns.template.strokeWidth = 0;

    // chart bar에 rate label 표시 및 위치, 크기 설정
    let valueLabel = series.columns.template.createChild(am4core.Label);
    valueLabel.text = '{rate}';
    valueLabel.fontSize = 12;
    // TODO: 추후 bold weight 설정 필요에 따라 적용
    valueLabel.fontWeight = 'bold';
    valueLabel.align = 'left';
    valueLabel.dx = 210;
    valueLabel.dy = -6;
    valueLabel.strokeWidth = 0;

    // y축과 관련된 grid line 제거
    categoryAxis.renderer.grid.template.disabled = true;

    // x축과 관련된 grid line 및 기준 값 제거
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;

    // x축이 가질 수 있는 최소~최대값 지정
    valueAxis.min = 0;
    valueAxis.max = 2;

    // x축 사이즈에 대한 스케일지정
    valueAxis.scale = 1.3;

    // chart bar의 round 값 지정
    series.columns.template.column.cornerRadiusTopLeft = 10;
    series.columns.template.column.cornerRadiusTopRight = 10;
    series.columns.template.column.cornerRadiusBottomLeft = 10;
    series.columns.template.column.cornerRadiusBottomRight = 10;

    // chart bar에 색상 채우기
    series.columns.template.adapter.add('fill', (fill, target) => {
      let gradient = new am4core.LinearGradient();
      if (target.dataItem.index) {
        gradient.addColor(am4core.color('#69D5A8'));
        gradient.addColor(am4core.color('#6ECBFD'));
      } else {
        gradient.addColor(am4core.color('#F44E9E'));
        gradient.addColor(am4core.color('#FC7979'));
      }
      return gradient;
    });

    // accuracy, in-time의 위치 바꾸기(column title)
    categoryAxis.renderer.inside = true;
    categoryAxis.renderer.dy = -13;
    categoryAxis.renderer.dx = -9;
    categoryAxis.renderer.fontWeight = 'bold';
    categoryAxis.renderer.fontSize = 12;
    return () => {
      chart.dispose(); //TODO: dispose 말고 그냥 data만 변경하는 방법이 있을 듯
    };
  }, [chartId, stringifiedData]);

  return <div id={chartId} style={{ width: '100%', height: '120px' }} />;
};

export default Chart;
